import { createFileRoute, redirect } from "@tanstack/react-router";

import { isLobbyDemoMode, redirectIfUserIsAuthenticated } from "app/lib/helpers";
import { loadAuthEndpoints, loadLobbyConfig } from "app/lib/loaders";
import { SignInPage } from "pages/sign-in";

type SignInSearch = {
  modal?: "log-in" | "register" | "password-forgot";
};

export const Route = createFileRoute("/sign-in")({
  component: SignInPage,
  onError: console.error,
  loader: () => Promise.all([loadLobbyConfig(), loadAuthEndpoints()]),
  validateSearch: (search: Record<string, unknown>): SignInSearch => ({
    modal: search.modal as SignInSearch["modal"],
  }),
  beforeLoad: async () => {
    await redirectIfUserIsAuthenticated("/");

    if (isLobbyDemoMode()) {
      throw redirect({
        to: "/casino",
        replace: true,
        search: {
          modal: "log-in",
        },
      });
    }
  },
});
